import { cloneDeep } from 'lodash'
import GraphQLClient from '@aspedia/graphql_client'
import { formatTemplate } from '../utils/handlebars'
import { formatCSV, formatExportData, formatFilterFields, formatSortFields } from '../utils/formatter'

export default {
  methods: {
    endpointRequest: function(fetchStrategy, params) {
      if (fetchStrategy.type === 'rest') {
        return this.handleRESTRequest({
          method: fetchStrategy.method,
          body: fetchStrategy.body,
          endpoints: fetchStrategy.endpoint,
          headers: fetchStrategy.headers,
          params
        })
      }
      else {
        const variables = typeof fetchStrategy.variables === 'string' ? formatTemplate(fetchStrategy.variables, params) : fetchStrategy.variables
        const queryDoc = typeof fetchStrategy.query === 'string' ? formatTemplate(fetchStrategy.query, params) : fetchStrategy.query
        const endpoint = typeof fetchStrategy.endpoint === 'string' ? formatTemplate(fetchStrategy.endpoint, params) : fetchStrategy.endpoint
        const headers = typeof fetchStrategy.headers === 'string' ? formatTemplate(fetchStrategy.headers, params) : fetchStrategy.headers

        const graphqlclient = new GraphQLClient(endpoint, queryDoc)
        return graphqlclient.query({
          variables: variables ? JSON.parse(variables) : null,
          headers: headers ? JSON.parse(headers) : null
        })
      }
    },
    async handleRESTRequest({ method = 'GET', body = null, endpoints, headers = {}, params = {} }) {
      let options = {
        method: method,
        ...(headers && { headers: headers }),
        ...(params && { qs: params }),
        ...(body && { body: JSON.stringify(body) })
      }

      return fetch(endpoints, options)
        .then(async res => {
          if (res.ok) {
            const result = await res.json()
            return { data: result }
          }
        })
        .catch(error => console.error(error))
    },
    getData(params) {
      const vm = this
      this.filters = formatFilterFields(this.columnDefs, cloneDeep(params.request.filterModel))
      this.sortingList = formatSortFields(this.columnDefs, params.request.sortModel)
      if (!this.map.isPagination) {
        this.loaded()
      }
      // this.start = Object.prototype.hasOwnProperty.call(params.request, 'startRow') ? params.request.startRow : 0
      this.start = params.request.startRow
      this.loading = true
      if (this.start === 0) {
        this.rowCount = -1
      }
      const requestOptions = cloneDeep({
        queryStart: this.start || 0,
        queryLimit: this.map.fetchStrategy.limit,
        globals: {
          ...this.globalContext,
          ...this.map.fetchStrategy.context,
          ...this.map.context
        },
        sorts: this.sortingList,
        filters: this.filters
      })
      // console.log(JSON.stringify(requestOptions, null, 2))

      this.endpointRequest(this.map.fetchStrategy, requestOptions)
        .then((result) => {
          if (result.errors && !result.data) {
            console.error(result.errors)
          }

          let rows = result && result.data && result.data.data ? result.data.data : []

          if (rows.length !== this.map.fetchStrategy.limit) {
            vm.rowCount = params.request.startRow + rows.length
            if (!this.map.isPagination) {
              vm.scrollNoMore = true
              vm.noMore()
            }
          }

          if (this.map.isPagination && rows.length === 0) {
            params.api.showNoRowsOverlay()
          }
          params.success({ rowData: rows, rowCount: vm.rowCount })
          this.loading = false
        })
    },
    async handleServerExport() {
      window.onbeforeunload = () => {
        return 'Export in progress. Are you sure want to cancel?'
      }
      this.exportLoading = true

      const displayedColumns = this.gridAPI.serverSideRowModel.columnModel.displayedColumns
      const exportBatchSize = this.map.exportStrategy.batchSize || this.map.fetchStrategy.limit || 100
      const exportMessage = this.map.exportStrategy.message
      const content = []

      let start = 0
      let exportEnd = false

      while (!exportEnd) {
        let formattedExportMessage = `exporting at page  ${start + 1}-${start + exportBatchSize}`

        if (exportMessage && exportMessage.length) {
          formattedExportMessage = formatTemplate(exportMessage, {
            start: start,
            limit: exportBatchSize,
            batchSizes: exportBatchSize
          })
        }
        this.showToastMessage(formattedExportMessage, 0)
        const requestOptions = cloneDeep({
          queryStart: start,
          queryLimit: exportBatchSize,
          globals: {
            ...this.globalContext,
            ...this.map.fetchStrategy.context,
            ...this.map.context
          },
          sorts: this.sortingList,
          filters: this.filters
        })

        const contentData = await this.endpointRequest(this.map.fetchStrategy, requestOptions)
          .then(result => result.data?.data ? result.data.data : [])

        content.push(...formatExportData(displayedColumns, contentData, this.queriesData))
        if (contentData.length !== exportBatchSize) {
          exportEnd = true
        }
        start += exportBatchSize
      }
      const formattedCSV = formatCSV(displayedColumns, content)

      const url = window.URL.createObjectURL(
        new Blob([formattedCSV], { type: 'text/csv;charset=utf-8;' })
      )
      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute(
        'download',
        `Results.csv`
      )
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.onbeforeunload = null
      this.exportLoading = false

      let exportSuccessMessage = `Export success, total rows exported: ${content.length}`

      if (this.map.exportStrategy.successMessage) {
        exportSuccessMessage = formatTemplate(this.map.exportStrategy.successMessage, { total: content.length })
      }

      this.showToastMessage(exportSuccessMessage, 5000)
    },

    handlePreQueries() {
      const preQueries = this.map.preQuery

      if (preQueries && preQueries.length) {
        return Promise.all(preQueries.map(async item => {
          const handlerParams = {
            ...item.params,
            globals: {
              ...this.map.context,
              ...this.globalContext
            }
          }
          return this.endpointRequest(item, handlerParams)
            .then(res => item.keys.reduce((acc, key) => ({ ...acc, [key]: res.data[key] }), {}))
        }))
          .then(results => {
            return results.reduce((acc, values) => ({ ...acc, ...values }), {})
          })
      }
    }
  }

}
